import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    root: {
        height: '100%',
        width: '100%',
        padding: '10px 10px 10px 10px'
    },
    tableContainer: {
        overflow: 'auto',
        height: 'calc(100% - 100px)'
    },
    loaderContainer: {
        height: 'calc(100% - 100px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    moreCell: {
        padding: 0,
        fontSize: '20px',
        cursor: 'pointer'
    },
    headCell: {
        fontSize: '14px'
    },
    formControl: {
        margin: '8px 8px 8px 0px',
        minWidth: 120,
    },
    accountsText: {
        cursor: 'pointer'
    },
    topContainer: {
        display: 'flex'
    }
}));
